<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false"
           width="600">

      <Form ref="formValidate" :model="params" :rules="ruleValidate" label-position="top">
        <FormItem label="用户昵称：" prop="nickName">
          <Input v-model.trim="params.nickName" disabled></Input>
        </FormItem>
        <FormItem label="合作企业名称：" prop="companyName">
          <Input v-model.trim="params.companyName" placeholder="请输入合作企业名称"></Input>
        </FormItem>
      </Form>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
        <Button type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
          <span v-if="!loadingBtn">确定</span>
          <span v-else>请稍候...</span>
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      title: '设置合作企业',
      total: 0,
      params: {
        companyName: '',
        userId: '',
        nickName: ''
      },
      isTableLoading: false,
      // 表格数据
      data: [],
      ruleValidate: {
        companyName: [
          {required: true, message: '合作企业名称不能为空', trigger: 'change'},
        ],
      }
    }
  },
  methods: {
    // 显示模态框
    show(row) {
      this.isShowModal = true;
      this.params.userId = row.userId
      this.params.nickName = row.nickName
      this.params.companyName = ''
    },
    // 查询投诉及意见详情
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.axios.post('/cooperateCompany/save', this.params).then(res => {
            console.log(res);
            setTimeout(()=>{
              this.$Spin.hide();
            },300);
            if (res.status == 200) {
              this.$emit('changeDate');
              this.$Message.success('操作成功.');
              this.hide('formValidate');
            }
            if(res.status == 201){
              this.$Message.error(res.msg);
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '标记合作企业接口报错',
                duration: 0
              });
            }
          })
        }
      })
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      // this.$refs[name].resetFields();
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
  },
}
</script>

<style scoped>
.jw-images-row {
  display: flex;
  align-items: center;
}

.jw-image {
  width: 150px;
  height: 150px;
  margin-right: 10px;
}
</style>
